import Gsap from './plugins/animation.gsap';
import Debug from './plugins/debug.addIndicator';
import Velocity from './plugins/animation.velocity';
import JQuery from './plugins/selector.jquery';

export const ScrollMagicPluginGsap = Gsap;
export const ScrollMagicPluginIndicator = Debug;
export const ScrollMagicPluginVelocity = Velocity;
export const ScrollMagicPluginJQuery = JQuery;



//////////////////
// WEBPACK FOOTER
// ./~/scrollmagic-plugins/index.js
// module id = 25
// module chunks = 0